import { Pipe, PipeTransform } from "@angular/core";
import { UserDataModel } from "src/app/settings-interfaces/users.models";
import { UtilsService } from "src/app/shared";
@Pipe({
    name: "UserName",
    standalone: false,
})
export class UserNamePipe implements PipeTransform {
    transform(assignedUser: UserDataModel, DefaultValue: string): string {
        if (!assignedUser || UtilsService.isNullOrWhitespace(assignedUser.FirstName) || UtilsService.isNullOrWhitespace(assignedUser.LastName)) {
            return DefaultValue;
        }
        return assignedUser.FirstName + " " + assignedUser.LastName;
    }
}
